<template>
  <div id="app">
    <router-view></router-view>
    <side-bar></side-bar>
  </div>
</template>

<script>
  import "assets/js/flexible.js"
  import "assets/js/iconfont.js"
  import SideBar from "components/common/sidebar/SideBar.vue"
  export default {
    name: "App",
    components: {
      SideBar,
    }
  }
</script>

<style lang="less">
  @import "./assets/css/base.less";
</style>
